/**
 * Analytics Utility Functions
 *
 * Shared utilities used across analytics services.
 */

import { v4 as uuidv4 } from 'uuid'

/**
 * Generate a unique event ID for cross-provider event reconciliation.
 * Uses uuid v4 for a standard UUID format.
 *
 * This ID is included in events sent to all analytics providers (Mixpanel,
 * Braze, Segment, GA4) to enable joining/reconciling events in a data warehouse.
 */
export function generateEventId(): string {
    return uuidv4()
}

/**
 * Check if localStorage is available and functional.
 *
 * Returns false when localStorage is null (e.g. Chrome Mobile WebView)
 * or when access is blocked (e.g. privacy settings, iframe sandbox).
 */
export function isLocalStorageAvailable(): boolean {
    try {
        const key = '__ls_test__'
        window.localStorage.setItem(key, '1')
        window.localStorage.removeItem(key)
        return true
    } catch {
        return false
    }
}
